<div class="slim-sidebar">
  <!-- Logo / Icone no topo -->
  <div class="sidebar-brand">
    <img src="assets/images/menu.svg" alt="Avati" class="brand-logo" />
  </div>

  <!-- Itens principais do menu -->
  <nav class="sidebar-nav">
    <ul class="nav-list">
      <li *ngFor="let item of menuItems"
          class="nav-item"
          [class.active]="activeItem === item.key || selectedItem === item.key"
          [class.hidden]="!isItemVisivel(item)"
          (click)="toggleFlyout(item, $event)"
          (mouseenter)="onItemHover(item, $event)"
          [pTooltip]="!activeItem && !item.children ? (item.labelKey | translate) : ''"
          tooltipPosition="right">

        <!-- Icone principal -->
        <div class="nav-icon-wrapper">
          <i [class]="item.icon"></i>
        </div>
      </li>
    </ul>
  </nav>

  <!-- Area inferior: Planos, Config, Ajuda -->
  <div class="sidebar-footer">
    <!-- Itens de menu do footer (Planos, Configuracoes) -->
    <div *ngFor="let item of footerMenuItems"
         class="nav-item"
         [class.active]="activeItem === item.key || selectedItem === item.key"
         [class.nav-item-planos]="item.key === 'planos'"
         [class.nav-item-master]="item.key === 'area-master'"
         [class.hidden]="!isItemVisivel(item)"
         (click)="toggleFlyout(item, $event)"
         (mouseenter)="onItemHover(item, $event)"
         [pTooltip]="!activeItem && !item.children ? (item.labelKey | translate) : ''"
         tooltipPosition="right">
      <div class="nav-icon-wrapper">
        <i [class]="item.icon"></i>
      </div>
    </div>

    <!-- Ajuda / Suporte WhatsApp -->
    <a class="nav-item nav-item-whatsapp"
         href="https://wa.me/595993290585"
         target="_blank"
         [pTooltip]="'menu-lateral.tooltips.ajuda' | translate"
         tooltipPosition="right">
      <div class="nav-icon-wrapper">
        <i class="pi pi-whatsapp"></i>
      </div>
    </a>
  </div>
</div>

<!-- Flyout panel renderizado FORA do sidebar (position: fixed) -->
<ng-container *ngIf="activeItem && getActiveMenuItem() as activeMenu">
  <div class="flyout-panel"
       [style.top.px]="flyoutTop"
       (click)="$event.stopPropagation()">

    <!-- Header do flyout -->
    <div class="flyout-header">
      <i [class]="activeMenu.icon" class="flyout-header-icon"></i>
      <span class="flyout-title">{{ activeMenu.labelKey | translate }}</span>
    </div>

    <!-- Lista de sub-itens -->
    <ul class="flyout-list">
      <ng-container *ngFor="let child of getFilhosVisiveis(activeMenu)">

        <!-- Titulo de secao -->
        <li *ngIf="isSectionTitle(child)" class="flyout-section-title">
          {{ child.sectionTitle | translate }}
        </li>

        <!-- Separador simples (sem titulo) -->
        <li *ngIf="isSeparator(child)" class="flyout-separator" aria-hidden="true"></li>

        <!-- Item com sub-filhos (sub-submenu) -->
        <li *ngIf="!isSectionTitle(child) && !isSeparator(child) && hasChildren(child) && (!child.condicional || minishopHabilitado)"
            class="flyout-item flyout-item-parent"
            [class.expanded]="expandedSubItem === child.key || isSubItemSempreExpandido(child)"
            (click)="toggleSubItem(child, $event)">
          <div class="flyout-item-content">
            <i [class]="child.icon" class="flyout-item-icon"></i>
            <span class="flyout-item-label">{{ child.labelKey | translate }}</span>
            <i *ngIf="!isSubItemSempreExpandido(child)" class="pi flyout-chevron"
               [ngClass]="expandedSubItem === child.key ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </div>

          <!-- Sub-filhos -->
          <ul *ngIf="expandedSubItem === child.key || isSubItemSempreExpandido(child)" class="flyout-sublist">
            <li *ngFor="let subChild of getFilhosVisiveis(child)"
                class="flyout-item"
                [class.selected]="selectedItem === subChild.key"
                (click)="navigateTo(subChild); $event.stopPropagation()">
              <div class="flyout-item-content">
                <i [class]="subChild.icon" class="flyout-item-icon"></i>
                <span class="flyout-item-label">{{ subChild.labelKey | translate }}</span>
              </div>
            </li>
          </ul>
        </li>

        <!-- Item simples (link direto) -->
        <li *ngIf="!isSectionTitle(child) && !isSeparator(child) && !hasChildren(child) && (!child.condicional || minishopHabilitado)"
            class="flyout-item"
            [class.selected]="selectedItem === child.key"
            (click)="navigateTo(child)">
          <div class="flyout-item-content">
            <i [class]="child.icon" class="flyout-item-icon"></i>
            <span class="flyout-item-label">{{ child.labelKey | translate }}</span>
            <i *ngIf="child.externalLink" class="pi pi-external-link flyout-external-icon"></i>
          </div>
        </li>

      </ng-container>
    </ul>
  </div>
</ng-container>

<!-- Overlay para fechar flyout ao clicar fora -->
<div *ngIf="activeItem"
     class="flyout-overlay"
     (click)="closeFlyout()">
</div>
